<div class="row d-flex" [ngClass]="{ 'mt-4 mb-4': mappedData && mappedData.length > 0 }">
  <div *ngFor="let data of mappedData; last as isLast" class="col-6 col-md-4 col-lg-{{ itemsPerRow }} mb-2">
    <div class="card product-card">
      <div class="card-body">
        <div>
          <span class="favourite-icon-wrapper">
            <lib-favourite-product-icon [id]="data.product.id"></lib-favourite-product-icon>
          </span>
        </div>

        <div class="ribbon" *ngIf="data.product.extra?.ar?.itemstatuscode === 8">
          <div
            *ngIf="data.product.extra.ar.itemstatuscode == 8; else null" translate
            class="ribbon-child ribbon-black"
          >
            <div class="arrow-ribbon"></div>
            TO_BE_PHASED_OUT
          </div>
        </div>

        <div class="ribbon" *ngIf="data.product.extra?.pim?.isNews == true">
          <div
            *ngIf="data.product.extra.pim.isNews == true; else null" translate
            class="ribbon-child ribbon-news"
          >
            <div class="arrow-ribbon"></div>
            NEWS_BANNER
          </div>
        </div>

        <div class="ribbon" *ngIf="data.product.extra?.pim?.isJosamNews == true">
          <div
            *ngIf="data.product.extra.pim.isJosamNews == true; else null" translate
            class="ribbon-child ribbon-news-josam"
          >
            <div class="arrow-ribbon"></div>
            NEWS_BANNER
          </div>
        </div>

        <div class="ribbon" *ngIf="data.product.extra?.pim?.isBlackhawkNews == true">
          <div
            *ngIf="data.product.extra.pim.isBlackhawkNews == true" translate
            class="ribbon-child ribbon-news-josam"
          >
            <div class="arrow-ribbon"></div>
            NEWS_BANNER
          </div>
        </div>

        <div (click)="goToDetail(data.product)">
          <lib-image-carousel-minimal *ngIf="data.product.extra.images?.length > 0; else noimage"
            [images]="data.product.extra.images || []"
            imageClass="image-wrapper"
          ></lib-image-carousel-minimal>
          <ng-template #noimage>
            <div class="image-wrapper">
              <img
                [src]="'images/no-image.jpg' | gungImageUrl
                    :'type:list'
                "
                class="card-img-top img-fluid w-100"
                src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg"
                alt="NO IMAGE"
                class="img-fluid mx-auto d-block"
                loading=lazy
              />

            </div>
          </ng-template>
        </div>
        <div class="product-text pb-1">
          <div class="small font-weight-light">{{ data.product.id }}</div>
          <div class="small text-muted">{{ !isJosamProject ? data.product.extra?.ar?.q_popnr : data.product.extra?.ar?.artnrean }}</div>
          <div class="text-truncate">{{ data.product.name }}</div>
          <div class="text-truncate" *ngIf="data.product?.extra?._sr_bantalavi">
            {{ data.product?.extra?._sr_bantalavi }}
            {{ data.product?.extra?.ar?.enhetskod || '' }}
          </div>
          @if(data.product.extra._parentProduct?.extra.ar?.itemstatuscode === 98) {
            <div>
              <span *ngIf="data.price.customerDiscountPercent !== 0; else noDiscount"
                >
                <car-liner-price
                  [price]="data.price"
                  [display]="'code'"
                  type="GROSS"
                  [currency]="data.price.customerGrossPrice.currencyCode"
                  class="font-weight-bold"
                ></car-liner-price
                >&nbsp;
                  <span [class.blur]="hidePrice">
                    ({{ data.price.customerNetPrice.value | number: '1.2-2' }}&nbsp;-{{
                      data.price.customerDiscountPercent
                    }}%)
                  </span>
                </span
              >
              <ng-template #noDiscount>
                <car-liner-price
                  [price]="data.price"
                  [display]="'code'"
                  type="NET"
                  [currency]="data.price.customerNetPrice.currencyCode"
                  class="font-weight-bold"
                ></car-liner-price>
                @if (data.price.backendPrice?.levels?.[0]?.extra?.prl?.nettoejrabkod == '1') {
                  <span class="ml-2" translate>PRODUCT_WITHOUT_DISCOUNT</span>
                }
              </ng-template>
            </div>
          }

          <div class="d-flex">
            @if (data.product.extra._parentProduct?.extra.ar?.itemstatuscode === 98) {
              <lib-buy-btn [id]="data.product.id" [product]="data.product"></lib-buy-btn>
            } @else {
              <div class="buy-button-row flex-grow-1 align-self-center">
                <span></span>
              </div>
            }

            @if (isJosamProject) {
              @if (data?.product?.extra?.ar?.itemtypecd6 == 1) {
                <div class="included-items-icon-wrapper" *ngIf="data?.product?.extra?._hasIncludedIcon">
                  <i class="fad fa-sort-size-down" (click)="openIncludedItemsModal(data.product)"></i>
                </div>
              }
            } @else {
              <div class="included-items-icon-wrapper" *ngIf="data?.product?.extra?._hasIncludedIcon">
                <i class="fad fa-sort-size-down" (click)="openIncludedItemsModal(data.product)"></i>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="findError" class="col-12 mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>
